import { JSX, useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import { createPortal } from 'react-dom';
import CalendarIcon from '../../../src/assets/images/icons/calendar.png';
import './date.css';

export type DateFormat = 'MMM dd, EEE'| 'MMM dd';

interface TodoDateProps {
  dateFormat: DateFormat;
  date: Date;
  onTodoDateChange: (date: Date) => void;
}

const TodoDate = ({dateFormat, date, onTodoDateChange}:TodoDateProps): JSX.Element => {

    const formatDate = (date: Date | null): string => {
      return date ? format(date, dateFormat) : 'No date set';
    };

    const [isOpen, setIsOpen] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);

    const handleDateChange = (newDate : Date) => {
      console.log("newDate", newDate);
      onTodoDateChange(newDate);
      setIsOpen(false);
    };
  
    const handleInputClick = (e) => {
      const rect = e.currentTarget.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX
      });
      console.log(position.top, position.left);
      setIsOpen(!isOpen);
    };

    // Close when clicking outside
    useEffect(() => {
      if (!isOpen) return;
      
      const handleClickOutside = (e) => {
        const portalElement = document.getElementById('custom-date-portal');
        if (portalElement && !portalElement.contains(e.target) && 
            triggerRef.current && !triggerRef.current.contains(e.target)) {
          setIsOpen(false);
        }
      };
      
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);
  
    return (
      <div className="date-picker-container">
      <div 
        ref={triggerRef}
        className="todo-date-text none-select-text" 
        onClick={handleInputClick} >
        {dateFormat === 'MMM dd, EEE' ? <img src={CalendarIcon} className='calendar-icon'/> : <></>}
        {formatDate(date)}
      </div>
      
      {isOpen && createPortal(
        <div id="custom-date-portal">
          <div className="date-picker-overlay" onClick={() => setIsOpen(false)} />
          <div 
            className="date-picker-calendar" 
            style={{ 
              position: 'absolute',
              top: `${position.top}px`,
              left: `${position.left}px` 
            }}
          >
            <DatePicker
              selected={date}
              onChange={(date: Date) => handleDateChange(date)}
              showMonthDropdown
              showYearDropdown
              yearItemNumber={100}
              scrollableYearDropdown={true}
              dropdownMode="scroll"
              inline  // Important: render as inline calendar
            />
          </div>
        </div>,
        document.body
      )}
    </div>
    ); 
};
  
export default TodoDate;